export enum LeagueStatisticType {
  Goals= 'goals',
  Assists= 'assists',
  Scorers = 'top_scorers',
  Cards = 'cards',
  OwnGoals = 'own_goals',
}
